export default __webpack_public_path__ + "static/media/event_memo.028f5e7f.svg";